<template>
  <div class="landing-structure">
    <div
      v-for="(section, s) in $ml.get('sections')"
      :key="s"
    >
      <component v-bind:is="section.type" :content="section.content"/>
    </div>
  </div>
</template>
<script>
import gsap from "gsap";
import { TimelineMax } from 'gsap';
import Copertina from "@/components/Copertina.vue";
import Paragrafo from "@/components/Paragrafo.vue";
import Highlight from "@/components/Highlight.vue";
import VideoMostro from "@/components/VideoMostro.vue";
import Gallery from "@/components/Gallery.vue";
import Puntate from "@/components/Puntate.vue";
import Anteprima from "@/components/Anteprima.vue";
import Footer from "@/components/Footer.vue";
export default {
  props: ["content"],
  data() {
    return {
    };
  },
  created() {
    this.sections = _.cloneDeep(this.$ml.get("sections"));
  },
  mounted() {
  },
  methods: {
  },
  components: {
    Copertina,
    Paragrafo,
    Highlight,
    VideoMostro,
    Gallery,
    Puntate,
    Anteprima,
    Footer
  }
};
</script>
<style lang="scss" scoped>

</style>
